import { render, staticRenderFns } from "./PortalJob.vue?vue&type=template&id=06478725&scoped=true&"
import script from "./PortalJob.vue?vue&type=script&lang=js&"
export * from "./PortalJob.vue?vue&type=script&lang=js&"
import style0 from "./PortalJob.vue?vue&type=style&index=0&id=06478725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06478725",
  null
  
)

export default component.exports